import React from "react";
import { Link } from "react-router-dom";
import AppleSignin from "react-apple-signin-auth";

interface FormProps {
  label: string;
  placeholder: string;
  type: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  hasForgotPassword?: boolean;
}

export function FormComponent({
  label,
  placeholder,
  type,
  value,
  onChange,
  hasForgotPassword,
}: FormProps) {
  return (
    <div className="flex-col w-full gap-2">
      <div className={`flex ${hasForgotPassword ? "justify-between" : ""}`}>
        <label>{label}</label>
        {hasForgotPassword && (
          <Link to="#" className="text-primary text-sm font-semibold">
            Forgot Password?
          </Link>
        )}
      </div>
      <input type={type} placeholder={placeholder} value={value} onChange={onChange} />
    </div>
  );
}

export function LoginWithProvider({
  provider,
  icon,
  onClick,
}: {
  provider: string;
  icon: React.ReactNode;
  onClick: () => void;
}) {
  return provider === "Apple" ? (
    <AppleSignin
      authOptions={{
        clientId:
          "105050267996-62c84g3oefgo8cr04urk427vr43d4j8b.apps.googleusercontent.com",
        scope: "email name",
        redirectURI: "google.com",
        state: "state",
        nonce: "nonce",
        usePopup: true,
      }}
      uiType="dark"
      className="apple-auth-btn"
      buttonExtraChildren="Login with Apple"
      onSuccess={handleAppleLogin}
      onError={(error: any) => console.error(error)}
      skipScript={false}
      iconProps={{ style: { marginTop: "10px" } }}
      render={(props: any) => (
        <button
          onClick={props.onClick}
          className="rounded-lg border-2 flex items-center justify-center gap-2 border-txtSecondary/20 w-full hover:bg-primary/5 transition-colors duration-200"
        >
          <span className="text-base">{icon}</span>
          Login with {provider}
        </button>
      )}
    />
  ) : (
    <button
      onClick={onClick}
      className="rounded-lg border-2 flex items-center justify-center gap-2 border-txtSecondary/20 w-full hover:bg-primary/5 transition-colors duration-200"
    >
      <span className="text-base">{icon}</span>
      Login with {provider}
    </button>
  );
}

// Assuming handleAppleLogin function is defined elsewhere
function handleAppleLogin(response: any) {
  console.log("Apple login success", response);
}
